import { render, staticRenderFns } from "./SidebarNavLink.vue?vue&type=template&id=552e3390&scoped=true"
import script from "./SidebarNavLink.vue?vue&type=script&lang=js"
export * from "./SidebarNavLink.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavLink.vue?vue&type=style&index=0&id=552e3390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e3390",
  null
  
)

export default component.exports